function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useMemo, useRef, useEffect, useCallback, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import shallowEqual from 'shallowequal';
import { v4 as uuid } from 'uuid';
import Sortable from 'sortablejs';
import { useTranslation } from 'react-i18next';
import { ActionButton, TitleComponent, createTree, MousePositionedTooltip } from '@keen.io/ui-core';
import { useSearch } from '@keen.io/react-hooks';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { OrderByProperty } from './components';
import { DRAG_ANIMATION_TIME, RESULT_PROPERTY_NAME } from './constants';
import { filterSchema, createListFromSchema } from './utils';
import { Section, SortableContainer, OrderByContainer } from './OrderBy.styles';
import { mutateArray } from '../../utils';
import { setOrderBy, getGroupBy, getOrderBy } from '../../modules/query';
import { getCollectionSchema } from '../../modules/events';
import { AppContext, SearchContext } from '../../contexts';

var OrderBy = function OrderBy(_ref) {
  var collection = _ref.collection;
  var dispatch = useDispatch();

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var groups = useSelector(function (state) {
    var groupBy = getGroupBy(state);

    if (groupBy) {
      if (Array.isArray(groupBy)) return groupBy;
      if (typeof groupBy === 'string') return [groupBy];
    }

    return [];
  }, shallowEqual);

  var _useSelector = useSelector(function (state) {
    return getCollectionSchema(state, collection);
  }),
      schema = _useSelector.schema;

  var orderBy = useSelector(function (state) {
    return getOrderBy(state);
  });
  var orderByRef = useRef(orderBy);
  var isResultPropertyChosen = !!(orderBy === null || orderBy === void 0 ? void 0 : orderBy.find(function (el) {
    return el.propertyName === RESULT_PROPERTY_NAME;
  }));
  var sortableRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      propertiesTree = _useState2[0],
      setPropertiesTree = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      searchPropertiesPhrase = _useState4[0],
      setSearchPhrase = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      expandTree = _useState6[0],
      setTreeExpand = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDragged = _useState8[0],
      setDragMode = _useState8[1];

  var filteredSchema = filterSchema(schema, groups, orderBy);

  var resultObject = _defineProperty({}, t('query_creator_order_by.order_options_label'), [RESULT_PROPERTY_NAME, 'any']);

  var _useSearch = useSearch(createListFromSchema(filteredSchema), function (searchResult, phrase) {
    if (phrase) {
      var searchTree = {};
      searchResult.forEach(function (_ref2) {
        var path = _ref2.path,
            type = _ref2.type;
        searchTree[path] = type;
      });
      setSearchPhrase(phrase);
      setPropertiesTree(_objectSpread(_objectSpread({}, createTree(searchTree)), resultObject));
      setTreeExpand(true);
    } else {
      setTreeExpand(false);
      setPropertiesTree(null);
    }
  }, {
    keys: ['path', 'type'],
    threshold: 0.4
  }),
      searchHandler = _useSearch.searchHandler;

  var clearSearchHandler = useCallback(function () {
    setPropertiesTree(null);
    setSearchPhrase(null);
  }, []);
  var updateOrderBy = useCallback(function (orderSettings, id) {
    var orderBySettings = orderBy.map(function (order) {
      if (order.id === id) return orderSettings;
      return order;
    });
    dispatch(setOrderBy(orderBySettings));
  }, [orderBy]);
  var removeOrderBy = useCallback(function (id) {
    var orderBySettings = orderBy.filter(function (order) {
      return order.id !== id;
    });
    if (orderBySettings.length === 0) orderBySettings = undefined;
    dispatch(setOrderBy(orderBySettings));
  }, [orderBy]);
  var showOrderOptions = useMemo(function () {
    return groups.filter(function (group) {
      return group;
    }).length;
  }, [groups]);
  useEffect(function () {
    orderByRef.current = orderBy;
  }, [orderBy]);
  useEffect(function () {
    var dragGhost;
    new Sortable(sortableRef.current, {
      animation: DRAG_ANIMATION_TIME,
      filter: '.add-button',
      handle: '.drag-handle',
      onStart: function onStart() {
        setDragMode(true);
        setTreeExpand(false);
      },
      onMove: function onMove(evt) {
        return !evt.related.className.includes('add-button');
      },
      onEnd: function onEnd(evt) {
        if (orderByRef.current) {
          var updatedGroups = mutateArray(orderByRef.current, evt.oldIndex, evt.newIndex);
          dispatch(setOrderBy(updatedGroups));
          setDragMode(false);
          if (dragGhost) dragGhost.parentNode.removeChild(dragGhost);
        }
      },
      setData: function setData(dataTransfer, dragEl) {
        dragGhost = dragEl.cloneNode(true);
        var styles = {
          width: dragEl.offsetWidth,
          transform: 'translateX(-100%)',
          position: 'absolute'
        };
        Object.assign(dragGhost.style, styles);
        var tree = dragGhost.querySelector('[data-testid="properties-tree"]');
        if (tree) tree.remove();
        document.body.appendChild(dragGhost);
        dataTransfer.setDragImage(dragGhost, 10, 10);
      }
    });
  }, []);

  var isActionButtonDisabled = function isActionButtonDisabled() {
    return (!showOrderOptions || !Object.keys(filteredSchema).length || orderBy && orderBy.some(function (item) {
      return !item.propertyName;
    })) && isResultPropertyChosen;
  };

  var selectAndGroupDataTooltip = function selectAndGroupDataTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      color: colors.white[500]
    }, collection ? React.createElement("span", {
      "data-testid": "select-group-by"
    }, t('query_creator_order_by.define'), ' ', React.createElement("strong", null, t('query_creator_order_by.group_by')), ' ', t('query_creator_order_by.order_result')) : React.createElement("span", {
      "data-testid": "select-event-stream"
    }, t('query_creator_order_by.select'), ' ', React.createElement("strong", null, t('query_creator_order_by.event_stream')), ' ', t('query_creator_order_by.tooltip')));
  };

  return React.createElement(React.Fragment, null, React.createElement(TitleComponent, {
    isDisabled: !showOrderOptions
  }, t('query_creator_order_by.title')), React.createElement(MousePositionedTooltip, {
    isActive: !showOrderOptions,
    tooltipPortal: modalContainer,
    tooltipTheme: 'dark',
    renderContent: selectAndGroupDataTooltip
  }, React.createElement(Section, {
    "data-testid": "order-by-wrapper"
  }, React.createElement(SearchContext.Provider, {
    value: {
      expandTree: expandTree,
      searchPropertiesPhrase: searchPropertiesPhrase
    }
  }, React.createElement(SortableContainer, {
    ref: sortableRef
  }, orderBy && orderBy.map(function (_ref3) {
    var propertyName = _ref3.propertyName,
        direction = _ref3.direction,
        id = _ref3.id;
    return React.createElement(OrderByContainer, {
      key: id
    }, React.createElement(OrderByProperty, {
      property: propertyName === 'result' ? t('query_creator_order_by.order_options_label') : propertyName,
      orderDirection: direction,
      isEditAllowed: !isDragged,
      properties: propertiesTree ? propertiesTree : _objectSpread(_objectSpread({}, createTree(filteredSchema)), isResultPropertyChosen ? {} : resultObject),
      onSelectDirection: function onSelectDirection(value) {
        var orderSettings = {
          id: id,
          propertyName: propertyName,
          direction: value
        };
        updateOrderBy(orderSettings, id);
      },
      onSelectProperty: function onSelectProperty(value) {
        clearSearchHandler();
        var orderSettings = {
          id: id,
          propertyName: value,
          direction: direction
        };
        updateOrderBy(orderSettings, id);
      },
      onSearchProperties: searchHandler,
      onBlur: function onBlur() {
        if (!propertyName) removeOrderBy(id);
      },
      onRemove: function onRemove() {
        clearSearchHandler();
        removeOrderBy(id);
      }
    }));
  }), React.createElement(ActionButton, {
    className: "add-button",
    isDisabled: isActionButtonDisabled(),
    action: "create",
    onClick: function onClick() {
      var currentSettings = orderBy || [];
      dispatch(setOrderBy([].concat(_toConsumableArray(currentSettings), [{
        id: uuid(),
        propertyName: '',
        direction: 'DESC'
      }])));
    }
  }))))));
};

export default OrderBy;